
    function deshorten(arrOfArr) {
      var headers = arrOfArr.headers;
      var data = arrOfArr.data;
      return data.map(function (d) {
        var o = {};
        headers.forEach(function (h, i) {
          o[h] = d[i];
        })
        return o;
      });
    }

    var str = '{"headers":["agriculture","buildings","electricity","lulucf","manufacturing","transportation","lulucf_emission_mmt_co2"],"data":[[17.59,7.32,27.63,1.06,30.54,16.92,510.72]]}';
    var shortenedJson = JSON.parse(str);
    module.exports = deshorten(shortenedJson);
  